import * as React from 'react'

import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import { CustomFieldsIcon } from '@sales-center/components'

type NoCustomFieldsProps = {
  onClickAdd: () => void
}

export function NoCustomFields(props: NoCustomFieldsProps) {
  const { onClickAdd } = props

  return (
    <Card style={{ width: '360px' }}>
      <Box
        p={3}
        pt={4}
        display="flex"
        textAlign="center"
        flexDirection="column"
      >
        <Box mb={2.4}>
          <CustomFieldsIcon variant="large" />
        </Box>

        <Box mb={2.4}>
          <Typography variant="h6">Custom Fields</Typography>
        </Box>

        <Box mb={6}>
          <Typography variant="body2">
            Custom fields will appear on the Add Lead and/or Create Opportunity
            screens. Custom fields will also be available for reporting.
          </Typography>
        </Box>

        <Button variant="contained" color="primary" onClick={onClickAdd}>
          Add Custom Fields
        </Button>
      </Box>
    </Card>
  )
}
